import React from 'react';
import styled from '@emotion/styled';

// import Slick from 'components/Slick';

import vw from 'styles/utils';
import media from 'styles/media';

import podcasts from 'data/podcast';

function IEKTalks() {
  return (
    <Root>
      {/* <Slick
        // icon={require('assets/images/icons/sound.png')}
        // title="IEKTalks"
      >
        <Iframe src="https://embed.podcasts.apple.com/us/podcast/episode-16-%E9%BA%BB%E7%9C%81%E7%90%86%E5%B7%A5%E7%A7%91%E6%8A%80%E8%A9%95%E8%AB%96%E5%B0%8E%E8%AE%80-%E6%88%91%E5%80%91%E8%88%87%E7%BC%BA%E6%B0%B4%E7%9A%84%E8%B7%9D%E9%9B%A2-feat-%E5%B7%A5%E7%A0%94%E9%99%A2%E7%94%A2%E7%A7%91%E5%9C%8B%E9%9A%9B%E6%89%80%E9%82%B1%E7%B4%94%E6%85%A7%E5%88%86%E6%9E%90%E5%B8%AB/id1562081118?i=1000568250689&amp;itsct=podcast_box_player&amp;itscg=30200&amp;ls=1&amp;theme=auto" height="175px" frameborder="0" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allow="autoplay *; encrypted-media *;" />
        <Iframe src="https://embed.podcasts.apple.com/us/podcast/episode-12-%E6%8F%AD%E5%AF%862022%E8%B6%A8%E5%8B%A2%E9%97%9C%E9%8D%B5%E5%AD%97-%E8%AE%8A%E8%BA%AB%E7%94%A2%E6%A5%AD%E4%BA%94-%E9%9B%B6-%E9%AB%98%E6%89%8B-feat-%E8%98%87%E5%AD%9F%E5%AE%97%E6%89%80%E9%95%B7/id1562081118?i=1000552180804&amp;itsct=podcast_box_player&amp;itscg=30200&amp;ls=1&amp;theme=auto" height="175px" frameborder="0" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allow="autoplay *; encrypted-media *;" />
        <Iframe src="https://embed.podcasts.apple.com/us/podcast/episode-08-%E5%9C%B0%E7%90%83%E7%99%BC%E7%87%92-%E5%A4%A9%E7%81%BD%E9%A0%BB%E5%82%B3-%E6%B7%A8%E9%9B%B6%E6%B8%9B%E7%A2%B3%E4%B8%8D%E8%83%BD%E7%AD%89/id1562081118?i=1000532459870&amp;itsct=podcast_box_player&amp;itscg=30200&amp;ls=1&amp;theme=auto" height="175px" frameborder="0" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allow="autoplay *; encrypted-media *;" />
        <Iframe src="https://embed.podcasts.apple.com/us/podcast/episode-09-%E7%96%AB%E5%BE%8C%E4%BC%81%E6%A5%AD%E8%BD%89%E5%9E%8B-%E6%95%B8%E4%BD%8D%E5%8C%96%E6%9C%80%E8%A1%8C/id1562081118?i=1000535358851&amp;itsct=podcast_box_player&amp;itscg=30200&amp;ls=1&amp;theme=auto" height="175px" frameborder="0" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allow="autoplay *; encrypted-media *;" />
      </Slick> */}
      {
        podcasts.map((podcast) => (
          <Iframe key={podcast} id="embedPlayer" src={podcast} frameborder="0" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allow="autoplay *; encrypted-media *; clipboard-write" />
        ))
      }
    </Root>
  )
}

IEKTalks.propTypes = {}

const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* margin-top: 50px; */

  ${vw('border-radius', 2)}
  ${vw('column-gap', 20)}
  /* ${vw('margin-bottom', 20, 30)} */

  @media ${media.tablet} {
    flex-direction: row;
  }

  @media ${media.desktop} {
    flex-direction: column;
  }
`;

const Iframe = styled.iframe`
  width: 100%;
  height: auto;
  /* height: 200%; */
  min-height: 59px;
  border: none;
  outline: none;
  /* width: 100%;  */
  /* max-width: 660px;  */
  overflow: hidden; 
  border-radius: 10px; 
  background: transparent;

  ${vw('margin-bottom', 12)}
  ${vw('min-height', 140, 189, 240)}
  /* ${vw('padding-left', 5)}
  ${vw('padding-right', 5)} */
  
  @media ${media.tablet} {
    width: 50%;
  }

  @media ${media.desktop} {
    width: 100%;
  }
`;

export default IEKTalks
